let fileUrl = process.env.REACT_APP_CF_IMG_URL
const baseUrl = process.env.REACT_APP_BASE_URL;
const streamingUrl = process.env.REACT_APP_CF_IMG_OUTPUT_URL
const storyUrl = process.env.REACT_APP_STORIES_URL;
export { baseUrl, fileUrl, streamingUrl ,storyUrl};
